"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axios = exports.messages = void 0;
const axios_1 = __importDefault(require("axios"));
const refreshToken_1 = require("./refreshToken");
exports.messages = {
    400: 'Bad Request',
    401: 'Unauthorized',
    404: 'Not Found',
    405: 'Method Not Allowed',
    422: 'Unprocessable Entity',
    429: 'Too many requests',
    500: 'Internal Server Error',
    502: 'Bad Gateway Error',
};
const defaultErrorMessage = 'Unexpected Error';
axios_1.default.interceptors.response.use((response) => {
    var _a;
    // Если в запросе со статусом 200 есть поле error считаем такой запрос ошибочный
    if (response.status === 200 && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.error)) {
        throw {
            error: response.data.error,
            status: response.status,
            data: response.data
        };
    }
    return response;
}, (error) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    // Если пришёл ответ от сервера, то обрабатываем его
    if (error === null || error === void 0 ? void 0 : error.response) {
        if (typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) !== 'object') {
            error.response.data = {};
        }
        if (!((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.message)) {
            error.response.data.message = exports.messages[(_c = error.response) === null || _c === void 0 ? void 0 : _c.status] || defaultErrorMessage;
        }
        if (((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) === 401 && refreshToken_1.isLoadingRefreshToken) {
            const originalRequest = error.config;
            yield new Promise((resolve) => setTimeout(resolve, 1000));
            return (0, exports.Axios)(originalRequest);
        }
        return Promise.reject({
            message: error.response.data.message,
            status: (_e = error.response) === null || _e === void 0 ? void 0 : _e.status,
            data: error.response.data,
            responseError: error
        });
    }
    // Иначе это ошибка Axios
    return Promise.reject({ message: error.message || defaultErrorMessage, responseError: error });
}));
exports.Axios = axios_1.default;
